<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-toolbar-title>Company Information</v-toolbar-title>
        <v-toolbar-title bottom v-if="disabled">
          <v-btn text color="primary" @click="disabled = false" v-if="disabled">
            {{ labels.edit }}
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn text color="primary" @click="updateCurrYear" v-if="enableUpdate">
            {{ labels.updateCurrYr }}
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <message :messages="messages"></message>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 md6 xs12>
              <v-text-field
                v-model="companyForm.coName"
                :label="labels.coName"
                :error-messages="errors.collect('coName')"
                :disabled="disabled"
                data-vv-name="coName"
                :data-vv-as="labels.coName"
                v-validate="'required|max:60'"
              ></v-text-field>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-text-field
                v-model="companyForm.coAddr1"
                :label="labels.address"
                :error-messages="errors.collect('coAddr1')"
                :disabled="disabled"
                data-vv-name="coAddr1"
                :data-vv-as="labels.address"
                v-validate="'required|max:60'"
              ></v-text-field>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-text-field
                v-model="companyForm.coAddr2"
                :error-messages="errors.collect('coAddr2')"
                :disabled="disabled"
                data-vv-name="coAddr2"
                v-validate="'max:60'"
              ></v-text-field>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-text-field
                v-model="companyForm.coAddr3"
                :error-messages="errors.collect('coAddr3')"
                :disabled="disabled"
                data-vv-name="coAddr3"
                v-validate="'max:60'"
              ></v-text-field>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-text-field
                v-model="companyForm.coAddr4"
                :error-messages="errors.collect('coAddr4')"
                :disabled="disabled"
                data-vv-name="coAddr4"
                v-validate="'max:60'"
              ></v-text-field>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-text-field
                v-model="companyForm.state"
                :label="labels.state"
                :error-messages="errors.collect('state')"
                :disabled="disabled"
                data-vv-name="state"
                :data-vv-as="labels.state"
                v-validate="'max:60'"
              ></v-text-field>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-autocomplete
                :label="labels.country"
                :items="countryList"
                v-model="companyForm.country"
                item-text="ctyDesc"
                item-value="ctyDesc"
                data-vv-name="country"
                :data-vv-as="labels.country"
                v-validate="'required'"
                :disabled="disabled"
                :error-messages="errors.collect('country')"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex lg6 md6 xs12>
              <v-text-field
                v-model="companyForm.coRegNo"
                :label="labels.coRegNo"
                :error-messages="errors.collect('coRegNo')"
                :disabled="disabled"
                data-vv-name="coRegNo"
                :data-vv-as="labels.coName"
                v-validate="'max:20'"
              ></v-text-field>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-text-field
                v-model="companyForm.gstRegNo"
                :label="labels.gstRegNo"
                :error-messages="errors.collect('gstRegNo')"
                :disabled="disabled"
                data-vv-name="gstRegNo"
                :data-vv-as="labels.gstRegNo"
                v-validate="'max:20'"
              ></v-text-field>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-text-field
                v-model="companyForm.webPage"
                :label="labels.webPage"
                :error-messages="errors.collect('webPage')"
                :disabled="disabled"
                data-vv-name="webPage"
                :data-vv-as="labels.webPage"
                v-validate="'max:50'"
              ></v-text-field>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-text-field
                v-model="companyForm.email"
                :label="labels.email"
                :error-messages="errors.collect('email')"
                :disabled="disabled"
                data-vv-name="email"
                :data-vv-as="labels.email"
                v-validate="'max:50'"
              ></v-text-field>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-text-field
                v-model="companyForm.contactNo"
                :label="labels.contactNo"
                :error-messages="errors.collect('contactNo')"
                :disabled="disabled"
                data-vv-name="contactNo"
                :data-vv-as="labels.contactNo"
                v-validate="'max:20'"
              ></v-text-field>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-text-field
                v-model="companyForm.masCo"
                :label="labels.masCo"
                :error-messages="errors.collect('masCo')"
                :disabled="disabled"
                data-vv-name="masCo"
                :data-vv-as="labels.masCo"
                v-validate="'max:10'"
              ></v-text-field>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-text-field
                v-model="companyForm.guarantor"
                :label="labels.guarantor"
                :error-messages="errors.collect('guarantor')"
                :disabled="disabled"
                data-vv-name="guarantor"
                :data-vv-as="labels.guarantor"
                v-validate="'max:8'"
              ></v-text-field>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-autocomplete
                :label="labels.baseCty"
                :items="countryList"
                v-model="companyForm.baseCty"
                item-text="ctyDesc"
                item-value="cty"
                data-vv-name="baseCty"
                :data-vv-as="labels.baseCty"
                v-validate="'required'"
                :disabled="disabled"
                :error-messages="errors.collect('baseCty')"
              ></v-autocomplete>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-autocomplete
                :label="labels.baseCurr"
                :items="currencyList"
                v-model="companyForm.baseCurr"
                item-text="currDesc"
                item-value="curr"
                data-vv-name="baseCurr"
                :data-vv-as="labels.baseCurr"
                v-validate="'required'"
                :disabled="disabled"
                :error-messages="errors.collect('baseCurr')"
              ></v-autocomplete>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-subheader class="queryLabel">{{ labels.currAcctYr }}</v-subheader>
              <div class="queryValue">{{ companyForm.currAcctYr }}</div>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-checkbox disabled v-model="companyForm.reinstate" :label="labels.reinstate"></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex lg6 md6 xs12>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ companyForm.createdBy }}</div>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ companyForm.createdDate }}</div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex lg6 md6 xs12>
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ companyForm.modifiedBy }}</div>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ companyForm.modifiedDate }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" dark @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
        <v-btn color="primary" dark @click="doSave" v-if="!disabled">
          {{ labels.update }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      disabled: true,
      enableUpdate: false,
      labels: {
        company: 'Company Information',
        coName: 'Company Name',
        address: 'Address',
        state: 'State',
        country: 'Country',
        coRegNo: 'Company Registration No.',
        gstRegNo: 'GST Registration No.',
        webPage: 'Web Page',
        email: 'Email Address',
        contactNo: 'Contact No.',
        masCo: 'MAS Company',
        guarantor: 'Guarantor',
        baseCty: 'Base Country',
        baseCurr: 'Base Currency',
        currAcctYr: 'Current Accounting Year',
        reinstate: 'Is Accounting Year Reinstated',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        edit: 'Edit',
        update: 'Update',
        updateCurrYr: 'Update Current Year'
      },
      companyForm: {},
      sideFunction: [
        {
          text: 'Branch',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'branchList' }
        },
        {
          text: 'Department',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'dept' }
        }
      ],
      countryList: [],
      currencyList: []
    }
  },
  mounted() {
    this.doFetch()
    this.doInitRelatedLinks()
  },
  methods: {
    // AR: Added to resolved loading issue 9/Oct
    async doInitRelatedLinks() {
      await Promise.all([this.$store.dispatch('branchManagementInit')])
      await Promise.all([this.$store.dispatch('deptManagementInit')])
    },
    async doFetch() {
      const apiURI = this.menu.getCompany
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.get(expandURI(apiURI))
          const { data } = result
          if (data) {
            this.countryList = data.countryList
            this.currencyList = data.currencyList
            this.setData(data)
            if (this.companyForm.glSys === 2) {
              this.enableUpdate = true
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          const config = {
            method: 'put',
            url: this.menu.updateCompany,
            data: this.companyForm
          }
          if (config.url) {
            this.$http
              .request(config)
              .then((result) => {
                const { data } = result
                this.notify(data)
                this.setData(data)
                this.disabled = true
              })
              .catch((err) => {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    setData(data) {
      var companyData = {
        coName: data.coName,
        coAddr1: data.coAddr1,
        coAddr2: data.coAddr2,
        coAddr3: data.coAddr3,
        coAddr4: data.coAddr4,
        state: data.state,
        country: data.country,
        coRegNo: data.coRegNo,
        gstRegNo: data.gstRegNo,
        webPage: data.webPage,
        email: data.email,
        contactNo: data.contactNo,
        masCo: data.masCo,
        guarantor: data.guarantor,
        baseCty: data.baseCty,
        baseCurr: data.baseCurr,
        currAcctYr: data.currAcctYr,
        reinstate: data.reinstate,
        createdBy: data.createdBy,
        createdDate: formatDisplayDate(data.createdDate),
        modifiedBy: data.modifiedBy,
        modifiedDate: formatDisplayDate(data.modifiedDate),
        glSys: data.glSys
      }
      this.companyForm = companyData
      this.old = Object.assign({}, companyData)
    },
    doCancel() {
      this.$router.push({ name: 'paramGlobal' })
    },
    updateCurrYear() {
      this.companyForm.currAcctYr = new Date().getFullYear()
      this.doSave()
    }
  },
  computed: {
    menu() {
      return this.$store.state.company.menu
    }
  },
  mixins: [MessageMixin],
  components: {
    SideFunctionMenu
  }
}
</script>
